import { render, staticRenderFns } from "./asideNav.vue?vue&type=template&id=0beb20ee&"
import script from "./asideNav.vue?vue&type=script&lang=js&"
export * from "./asideNav.vue?vue&type=script&lang=js&"
import style0 from "./asideNav.vue?vue&type=style&index=0&id=0beb20ee&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports